import {EsimPackage} from '@guestapp/sdk';

export const groupByDays = (esimPackages: EsimPackage[] = []) => {
  const grouped = esimPackages.reduce(
    (acc: Record<number, EsimPackage[]>, esimPackage: EsimPackage) => {
      acc[esimPackage.package_days] = acc[esimPackage.package_days] || [];
      acc[esimPackage.package_days].push(esimPackage);
      return acc;
    },
    {} as Record<number, EsimPackage[]>,
  );

  return Object.entries(grouped).map(([days, packages]) => ({
    days: Number(days),
    packages,
  }));
};
